var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"name":"check-box"}},[(_vm.checked)?_c('img',{staticClass:"check-image",attrs:{"src":require("../../assets/checked.png")},on:{"click":_vm.onClick}}):_c('img',{staticClass:"check-image",attrs:{"src":require("../../assets/unchecked.png")},on:{"click":_vm.onClick}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-258d3d01","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/CheckBox.vue
// module id = null
// module chunks = 